import { h, Component } from 'preact'
import ContentCurationList from './ContentCurationList'
import ContentCurationItem from './ContentCurationItem'
import ArticleIcon from '../assets/icon-content-type-article'
import QuestionIcon from '../assets/icon-content-type-question'
import AnswerIcon from '../assets/icon-content-type-answer'
import DiscussionIcon from '../assets/icon-content-type-discussion'
import IdeaIcon from '../assets/icon-content-type-idea'
import {CuratedTopic} from './HomepageContentCurationManager'
import axios, {AxiosResponse} from 'axios'

interface Props {
  data: Array<number>
  title: string
}

interface CuratedTopicWithIconAndIdx extends CuratedTopic {
  icon?: JSX.Element
  idx?: number
}

interface State {
  data: Array<CuratedTopic>
}

class HomepageContentCurationContainerFetch extends Component<Props, State> {
  constructor (props: Props) {
    super()
    this.state = {
      data: []
    }
  }

  async componentDidMount() {
    if (this.props.data.length === 0) {
      return
    }
    const {data}: AxiosResponse<{content: Array<CuratedTopic>}> = await axios.get('/contentCuration/getTopics', {
      params: {
        topicIds: this.props.data
      }
    })
    this.setState({data: data.content})
  }
  render (props: Props, state: State) {
    if (!state.data.length) return null
    return <HomepageContentCurationContainer title={props.title} data={state.data} />
  }
}


interface EnrichedProps {
  data: Array<CuratedTopicWithIconAndIdx>
  title: string
}

export const HomepageContentCurationContainer = (props: EnrichedProps) => {
  const topicType = {
    'question': <QuestionIcon />,
    'article': <ArticleIcon />,
    'answer': <AnswerIcon />,
    'discussion': <DiscussionIcon />,
    'idea': <IdeaIcon />
  }

  return <section className='topic-curation__container homepage-widget-wrapper full-width custom-featured-topic-list'>
    <div className='sitewidth'>
      <div className='col'>
        <div className='box__pad'>
          <h3 className='widget__heading m-b'>{props.title}</h3>
          {
            props.data.length ? (
              <ContentCurationList>
                { props.data.map((item, idx) => {
                  item.icon = topicType[item.type]
                  item.idx = idx
                  return <ContentCurationItem {...item} />
                })}
              </ContentCurationList>
            ) : null
          }
        </div>
      </div>
    </div>
  </section>
}

export default HomepageContentCurationContainerFetch
